<template>
	<div>
		<van-pull-refresh v-model="refreshing" @refresh="onRefresh" >
		  <van-list
		    v-model="loading"
		    :finished="finished"
		    :finished-text="finishedText"
		    @load="getsearch"
		    offset="200"
		    :immediate-check="false"
		    ref="list"
		  >
		  <div class="positionitem"
		  v-for="(item, index) in position_items"
		  :key="index"
		  @click="detail(item)"
		  >
		  	<div class="positioncode">职位编号：{{item.positionCode}}</div>
		  	<div class="positionname">职位名称：{{item.positionName}}</div>
		  	<div class="positioninfo">{{item.zyear}}年 | {{item.organs}}</div>
		  	<div class="positionarrow"><van-icon name="arrow" size="30" color="#cccccc"/></div>
		  </div>
		  
		  </van-list>
		  </van-pull-refresh>
		  <van-empty description="未查询到数据" v-show="this.total==0"/>
	</div>
</template>

<script>
	import {api_base} from '@/common/Request.js';
	import qs from 'qs'
	
	export default {
	  data () {
	    return {
	    value: '',
		has_next: true,
		position_items:[],
		poster:'',
		finished: false,
		loading:false,
		refreshing: false,
		finishedText:"没有更多",
		total:0,
		pageSize:10,
		position_pageno:1,
		position_exdata:'',
	    position_education:'',
	    position_year:'',
	    position_workyears:'',
	    position_positiontype:'',
	    position_specialtyexam:'',
		position_arr:[]
	
	    }
	  },
	  mounted (){
	
		 console.log(this.$route.query.position_year);
	   //    console.log(this.$route.query.position_workyears[0]);
	   //    console.log(this.$route.query.position_education[0]);
	   //    console.log(this.$route.query.position_positiontype[0]);
	   //    console.log(this.$route.query.position_specialtyexam[0]);
	   
	   //console.log(this.position_arr);
	   
	      this.paramload();
	
	      this.getsearch();
	  },
	  methods: {
	  paramload(){
	    console.log(this.$route.query);
	    const querylist=this.$route.query;
	    for(var querykey in querylist){
	    		   if(querylist[querykey]!='全部'){
	    			   this.position_arr[querykey.substring(9)]=querylist[querykey];
	    		   }
	    }
	  },getsearch(){
			//this.hotitemx="ok";
			//console.log(this.hotitemx);
	    //console.log('http://v.huazhi.cn/slim/app_v1/base/position_search/'+this.position_positiontype+'/null/null/null/'+this.position_specialtyexam+'/'+this.position_education+'/null/null/null/'+this.position_workyears+'/'+this.position_year+'/10/'+this.position_pageno);
		this.loading=true;
		if (this.refreshing) {
		          this.position_items = [];
		          this.refreshing = false;
		}
		if (this.has_next){
			this.position_arr.pageSize=10;
			this.position_arr.pageNo=this.position_pageno;
			console.log(this.position_arr);
			var arrstr=qs.stringify(this.position_arr);
		api_base.position_search(arrstr).then(response => {
			    console.log(response.data);
			const list =response.data.records;
	        this.position_items = [...this.position_items,...list];
			this.total = parseInt(response.data.total);
			console.log(this.total);
			this.loading=false;
			if(this.total>0&&this.total>this.pageSize){
			if ((this.position_pageno) * this.pageSize < this.total) {
			  this.has_next = true;
			} else {
			  this.has_next = false;
			}
			this.position_pageno++;
			}
			else{
				console.log(this.loading);
				console.log(this.refreshing);
				console.log(this.finished);
				this.finished=true;
				this.finishedText="";
				this.has_next=false;
			}
			
			})
			.catch(err=>{
				console.log(err);
				})
			}
			else{
				this.loading=false;
			}
		},
		onRefresh(){
		console.log("refresh");
		this.refreshing=true;
		this.finished = false;
		this.position_items=[];
		  this.position_pageno = 1;
		  this.has_next = true;
		  this.getsearch();
		},
		detail(item){
			this.$router.push({
			  path: "position_detail",
			  query: { position_id: item.id }
			});
		}
	  }
	}
	
</script>

<style lang="scss" scoped>
	.positionitem{
		flex:1 1 100%;
		border-bottom: solid 1px #CCCCCC;
		padding: 0.625rem;
		position: relative;
		.positioncode{
			font-weight: bolder;
			height: 1.875rem;
			line-height: 1.875rem;
			color:#666666;
		}
		.positionname{
			height: 1.875rem;
			line-height: 1.875rem;
			color: #999999;
			font-size:0.8rem;
			padding-right: 4rem;
			overflow: hidden;
		}
		.positioninfo{
			height: 1.875rem;
			line-height: 1.875rem;
			color: #999999;
			font-size: 0.8rem;
		}
		.positionarrow{
			position: absolute;
			top:0;
			right:0;
			height: 100%;
			padding-right: 2rem;
			vertical-align: middle;
			i{
				margin-top: 2.5rem;
			}
		}
	}
</style>
